<div *ngIf="solicitado == 0">
    <h4 class="center">Mi paquete</h4>
    
    <table class="table table-striped">
        <thead>
            <tr>
                <td>Producto</td>
                <td>Precio</td>
                <td><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-circle" viewBox="0 0 16 16">
                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                  </svg></td>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let paqueteSelected of paquetesSeleccionados">
                <td>{{paqueteSelected.paquete}}</td>
                <td>{{paqueteSelected.precio | currency}}</td>
                <td>
                    <a (click)="eliminarPaqueteCliente(paqueteSelected.id, clienteid)">
                        <svg style="color: red;" width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-x-circle" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                            <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                        </svg>
                    </a> 
                </td>
            </tr>

            <tr *ngFor="let productoSelected of productosSeleccionados">
                <td>{{productoSelected.producto}}</td>
                <td>{{productoSelected.precio | currency}}</td>
                <td>
                    <a (click)="eliminarProductoCliente(productoSelected.id, clienteid)">
                        <svg style="color: red;" width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-x-circle" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                            <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                        </svg>
                    </a> 
                </td>
            </tr>

            <tr *ngFor="let placaSelected of placasSeleccionados">
                <td>Placa - {{placaSelected.nombre}} </td>
                <td> - </td>
                <td>
                    <a (click)="eliminarPlaca(placaSelected.id, clienteid)">
                    <svg style="color: red;" width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-x-circle" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                        <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                        </svg>
                    </a>
                </td>
            </tr>

            <tr *ngFor="let molduraSelected of moldurasSeleccionados">
                <td>Marco - {{molduraSelected.nombre}}</td>
                <td> - </td>
                <td>
                    <a (click)="eliminarMoldura(molduraSelected.id, clienteid)">
                    <svg style="color: red;" width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-x-circle" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                        <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                        </svg>
                    </a>
                </td>
            </tr>

            <tr *ngFor="let fondoMolduraSelected of fondosMoldurasSeleccionados">
                <td>Fondo Marco - {{fondoMolduraSelected.nombre}}</td>
                <td> - </td>
                <td>
                    <a (click)="eliminarFondoMolduraCliente(fondoMolduraSelected.id, clienteid)">
                    <svg style="color: red;" width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-x-circle" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                        <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                        </svg>
                    </a>
                </td>
            </tr>

            

            <tr *ngFor="let coloreSelected of coloresSeleccionados">
                <td> Color - {{coloreSelected.nombre}} </td>
                <td> - </td>
                <td><a (click)="eliminarColorCliente(coloreSelected.id, clienteid)">
                    <svg style="color: red;" width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-x-circle" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                        <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                        </svg>
                    </a></td>
            </tr>

            
            <tr *ngFor="let anilloSelected of anillosSeleccionados">
                <td>{{anilloSelected.nombre}} | {{anilloSelected.metal}} <br>Medida: {{anilloSelected.medida}} <br>{{anilloSelected.gramaje}} gramos</td>
                <td>{{anilloSelected.precio | currency}}</td>
                <td><a (click)="eliminarAnilloCliente(anilloSelected.id, clienteid)">
                    <svg style="color: red;" width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-x-circle" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                        <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                        </svg>
                    </a></td>
            </tr>

            <tr *ngFor="let viajeSelected of viajesSeleccionados">
                <td>{{viajeSelected.nombre}}</td>
                <td>{{viajeSelected.precio | currency}}</td>
                <td><a (click)="eliminarViajeCliente(viajeSelected.id, clienteid)">
                    <svg style="color: red;" width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-x-circle" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                        <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                        </svg>
                    </a></td>
            </tr>


            <tr *ngFor="let fiestaSelected of fiestasSeleccionadas">
                <td *ngIf="fiestaSelected.boletos_adulto > 0">{{fiestaSelected.nombre}} - {{fiestaSelected.boletos_adulto}} Boletos Adulto</td>
                <td *ngIf="fiestaSelected.boletos_adulto > 0">{{fiestaSelected.boletos_adulto * fiestaSelected.precio_boletos_adulto | currency}}</td>
                <td *ngIf="fiestaSelected.boletos_adulto > 0"><a (click)="eliminarBoletosAdulto(fiestaSelected.id, clienteid)">
                    <svg style="color: red;" width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-x-circle" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                        <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                        </svg>
                    </a></td>
            </tr>


            <tr *ngFor="let fiestaSelected of fiestasSeleccionadas">
                <td *ngIf="fiestaSelected.boletos_nino > 0">{{fiestaSelected.nombre}} - {{fiestaSelected.boletos_nino}} Boletos Niño</td>
                <td *ngIf="fiestaSelected.boletos_nino > 0">{{fiestaSelected.boletos_nino * fiestaSelected.precio_boletos_nino | currency}}</td>
                <td *ngIf="fiestaSelected.boletos_nino > 0"><a (click)="eliminarBoletosNino(fiestaSelected.id, clienteid)">
                    <svg style="color: red;" width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-x-circle" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                        <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                        </svg>
                    </a></td>
            </tr>

            <tr *ngFor="let dedicatoriaSelected of dedicatoriasSeleccionadas">
                <td>{{dedicatoriaSelected.nombre}}<br>
                    Dirigido a:<br>
                    {{dedicatoriaSelected.dirigido}}
                </td>
                <td>{{dedicatoriaSelected.texto}}</td>
                <td>
                    <a (click)="eliminarDedicatoriaCliente(dedicatoriaSelected.id, clienteid)">
                    <svg style="color: red;" width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-x-circle" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                        <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                        </svg>
                    </a>
                </td>
            </tr>


            <tr *ngFor="let descuentoAplicado of descuentosAplicados">
                <td>Código {{descuentoAplicado.codigo}}</td>
                <td>-{{descuentoAplicado.monto | currency}}</td>
                <td></td>
            </tr>

            <tr>
                <td>Total</td>
                <td>{{total | currency}}</td>
                <td></td>
            </tr>
            
        </tbody>
    </table>
    <div>
        <!-- <button  *ngIf="admin==true" class="fondoAmarillo border0 input90 bold" (click)="guardarPaquete(clienteid)">Solicitar Paquete</button><br><br> -->
        <button  class="fondoAmarillo border0 input90 bold" (click)="guardarPaquete(clienteid)">Solicitar Paquete</button><br><br>
    

        <span>Código de descuento</span>
        <input type="text" [(ngModel)]="codigo_descuento" class="form-control"><br>
        <button class="fondoAmarillo border0 input90 bold" (click)="aplicarDescuento(clienteid)">Aplicar Descuento</button><br><br>
    </div>
   

</div>

<div *ngIf="solicitado == 1">
    <h4 class="center">Resumen de mi paquete</h4>
    <table class="table table-striped">
        <thead>
            <tr>
                <td>Producto</td>
                <td>Precio</td>
                <td *ngIf="admin==true"></td>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let paqueteSelected of paquetesSeleccionados">
                <td>{{paqueteSelected.paquete}}</td>
                <td>{{paqueteSelected.precio | currency}}</td>
                <td *ngIf="admin==true">
                    <a (click)="eliminarPaqueteCliente(paqueteSelected.id, clienteid)">
                        <svg style="color: red;" width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-x-circle" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                            <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                        </svg>
                    </a> 
                </td>
            </tr>


            <tr *ngFor="let productoSelected of productosSeleccionados">
                <td>{{productoSelected.producto}}</td>
                <td>{{productoSelected.precio | currency}}</td>
                <td  *ngIf="admin==true">
                    <a (click)="eliminarProductoCliente(productoSelected.id, clienteid)">
                        <svg style="color: red;" width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-x-circle" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                            <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                        </svg>
                    </a> 
                </td>
            </tr>

            <tr *ngFor="let placaSelected of placasSeleccionados">
                <td>Placa - {{placaSelected.nombre}}</td>
                <td> - </td>
                <td *ngIf="admin==true">
                    <a (click)="eliminarPlaca(placaSelected.id, clienteid)">
                    <svg style="color: red;" width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-x-circle" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                        <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                        </svg>
                    </a>
                </td>
            </tr>

            <tr *ngFor="let molduraSelected of moldurasSeleccionados">
                <td>Marco - {{molduraSelected.nombre}}</td>
                <td> - </td>
                <td *ngIf="admin==true">
                    <a (click)="eliminarMoldura(molduraSelected.id, clienteid)">
                    <svg style="color: red;" width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-x-circle" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                        <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                        </svg>
                    </a>
                </td>
            </tr>

            <tr *ngFor="let fondoMolduraSelected of fondosMoldurasSeleccionados">
                <td>Fondo Marco - {{fondoMolduraSelected.nombre}}</td>
                <td> - </td>
                <td *ngIf="admin==true">
                    <a (click)="eliminarFondoMolduraCliente(fondoMolduraSelected.id, clienteid)">
                    <svg style="color: red;" width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-x-circle" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                        <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                        </svg>
                    </a>
                </td>
            </tr>

            <tr *ngFor="let coloreSelected of coloresSeleccionados">
                <td>Color - {{coloreSelected.nombre}}</td>
                <td> - </td>
                <td *ngIf="admin==true">
                    <a (click)="eliminarColorCliente(coloreSelected.id, clienteid)">
                    <svg style="color: red;" width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-x-circle" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                        <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                        </svg>
                    </a></td>
            </tr>

            <tr *ngFor="let anilloSelected of anillosSeleccionados">
                <td>{{anilloSelected.nombre}} | {{anilloSelected.metal}} <br>Medida: {{anilloSelected.medida}} <br>{{anilloSelected.gramaje}} gramos</td>
                <td>{{anilloSelected.precio | currency}}</td>
                <td *ngIf="admin==true"><a (click)="eliminarAnilloCliente(anilloSelected.id, clienteid)">
                    <svg style="color: red;" width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-x-circle" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                        <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                        </svg>
                    </a></td>
            </tr>


            <tr *ngFor="let viajeSelected of viajesSeleccionados">
                <td>{{viajeSelected.nombre}}</td>
                <td>{{viajeSelected.precio | currency}}</td>
                <td *ngIf="admin==true"><a (click)="eliminarViajeCliente(viajeSelected.id, clienteid)">
                    <svg style="color: red;" width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-x-circle" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                        <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                        </svg>
                    </a></td>
            </tr>


            <tr *ngFor="let fiestaSelected of fiestasSeleccionadas">
                <td *ngIf="fiestaSelected.boletos_adulto > 0">{{fiestaSelected.nombre}} - {{fiestaSelected.boletos_adulto}} Boletos Adulto</td>
                <td *ngIf="fiestaSelected.boletos_adulto > 0">{{fiestaSelected.boletos_adulto * fiestaSelected.precio_boletos_adulto | currency}}</td>
                <td *ngIf="fiestaSelected.boletos_adulto > 0 && admin==true"><a (click)="eliminarBoletosAdulto(fiestaSelected.id, clienteid)">
                    <svg style="color: red;" width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-x-circle" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                        <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                        </svg>
                    </a></td>
            </tr>


            <tr *ngFor="let fiestaSelected of fiestasSeleccionadas">
                <td *ngIf="fiestaSelected.boletos_nino > 0">{{fiestaSelected.nombre}} - {{fiestaSelected.boletos_nino}} Boletos Niño</td>
                <td *ngIf="fiestaSelected.boletos_nino > 0">{{fiestaSelected.boletos_nino * fiestaSelected.precio_boletos_nino | currency}}</td>
                <td *ngIf="fiestaSelected.boletos_nino > 0 &&  admin==true"><a (click)="eliminarBoletosNino(fiestaSelected.id, clienteid)">
                    <svg style="color: red;" width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-x-circle" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                        <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                        </svg>
                    </a></td>
            </tr>

            <tr *ngFor="let dedicatoriaSelected of dedicatoriasSeleccionadas">
                <td>{{dedicatoriaSelected.nombre}}<br>
                    Dirigido a:<br>
                    {{dedicatoriaSelected.dirigido}}
                </td>
                <td>{{dedicatoriaSelected.texto}}</td>
                <td *ngIf="admin==true">
                    <a (click)="eliminarDedicatoriaCliente(dedicatoriaSelected.id, clienteid)">
                    <svg style="color: red;" width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-x-circle" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                        <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                        </svg>
                    </a>
                </td>
            </tr>


        

            <tr *ngFor="let descuentoAplicado of descuentosAplicados">
                <td>{{descuentoAplicado.codigo}}</td>
                <td>-{{descuentoAplicado.monto | currency}}</td>
                <td *ngIf="admin==true">
                    <a (click)="eliminarDescuentoCliente(descuentoAplicado.id, clienteid)">
                        <svg style="color: red;" width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-x-circle" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                        <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                        </svg>
                    </a>
                </td>
            </tr>

            <tr>
                <td></td>
                <td>{{total | currency}}</td>
                <td *ngIf="admin==true"></td>
            </tr>
        </tbody>
    </table>


    <div *ngIf="admin==true">
        <!-- <button  *ngIf="admin==true" class="fondoAmarillo border0 input90 bold" (click)="guardarPaquete(clienteid)">Solicitar Paquete</button><br><br> -->
        <button  class="fondoAmarillo border0 input90 bold" (click)="guardarPaquete(clienteid)">Solicitar Paquete</button><br><br>
    

        <span>Código de descuento</span>
        <input type="text" [(ngModel)]="codigo_descuento" class="form-control"><br>
        <button class="fondoAmarillo border0 input90 bold" (click)="aplicarDescuento(clienteid)">Aplicar Descuento</button><br><br>
    </div>
</div>